import type { corrections as Fr } from '../fr/corrections';

/** « corrections » in English — typed on the French: a missing sentence does not compile. */
export const corrections: typeof Fr = {
  erreur: 'Error',
  titre: 'Approvals',
  sousTitre: (n: number, trancher: boolean) => `${n} pending · ${trancher ? 'you can decide' : 'your requests'}`,
  videTitre: 'Nothing pending',
  videTexte: 'No correction requests to review.',
  minutes: (m: number) => `${m} min`,
  heures: (h: number) => `${h} h`,
  demande: (nom: string) => `${nom} requests a correction`,
  champ: (entite: string, champ: string) => `${entite} — field “${champ}”`,
  financiere: 'Financial data',
  refuser: 'Reject',
  accorder: 'Approve',
  enAttente: 'Pending',
  historique: 'History',
  colDate: 'Date', colDemandeur: 'Requested by', colDossier: 'Record', colChamp: 'Field', colDecision: 'Decision', colTraitePar: 'Handled by',
  accorderTitre: 'Approve the correction',
  refuserTitre: 'Reject the correction',
  commentaire: 'Comment',
  commentaireAide: 'It will be kept in the audit log, with both values.',
  annuler: 'Cancel',
};
